import { memo, useCallback } from 'react'
import { TableColumnsType, Table } from 'antd'
import { PlayerToTeam } from 'types/players-to-teams'

type Props = {
    data: PlayerToTeam[]
}

export const TeamsExpandableRow = memo((props: Props) => {
    const { data } = props

    const columns: TableColumnsType<PlayerToTeam> = [
        { title: 'Team ID', dataIndex: 'teamId' },
        { title: 'League ID', dataIndex: 'leagueId' },
        { title: 'Position', dataIndex: ['position', 'name'] },
        {
            title: 'Role',
            key: 'role',
            render: (_, record) => (record.captain ? 'Captain' : record.viceCaptain ? 'Vice captain' : ''),
        },
    ]

    const getRowKey = useCallback(
        (record: PlayerToTeam) => `${record.teamId}-${record.leagueId}-${record.playerId}`,
        []
    )

    return <Table columns={columns} dataSource={data} pagination={false} rowKey={getRowKey} />
})
